import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { useHistory } from 'react-router';

const Header = () => {
  const { goBack } = useHistory();

  return (
    <Flex width='100%' justify='space-between' items='center'>
      <Flex>
        <Icon name='usermerge' size='medium' color='shuttleGray' />
        <Text size='x-x-large' weight='400' pl='1rem'>
          Invite User
        </Text>
      </Flex>
      <div onClick={goBack}>
        <Icon
          name='closeicon'
          size='smaller'
          color='shuttleGray'
          cursor='pointer'
        />
      </div>
    </Flex>
  );
};

export default Header;
